import { createContext } from 'react';

import { SelectedUserContextProps } from './SelectedUserContext.types';

export const SelectedUserContext = createContext<SelectedUserContextProps | undefined>(undefined);
